var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.66667C0 0.744792 0.734152 0 1.64286 0H21.3571C22.2658 0 23 0.744792 23 1.66667C23 2.58854 22.2658 3.33333 21.3571 3.33333H1.64286C0.734152 3.33333 0 2.58854 0 1.66667ZM0 10C0 9.07812 0.734152 8.33333 1.64286 8.33333H14.7857C15.6944 8.33333 16.4286 9.07812 16.4286 10C16.4286 10.9219 15.6944 11.6667 14.7857 11.6667H1.64286C0.734152 11.6667 0 10.9219 0 10ZM9.85714 18.3333C9.85714 19.2552 9.12299 20 8.21429 20H1.64286C0.734152 20 0 19.2552 0 18.3333C0 17.4115 0.734152 16.6667 1.64286 16.6667H8.21429C9.12299 16.6667 9.85714 17.4115 9.85714 18.3333Z",
    fill: "#8C9BA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon2);
export default __webpack_public_path__ + "static/media/sort-icon-2.4e1df0c5e875ea7c63445f4be0806ff8.svg";
export { ForwardRef as ReactComponent };